/**
 * @generated SignedSource<<7e61986e90184a861bbb7139b2504dc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PathwaySequenceDashboardBlockFragment$data = {
  readonly id: string;
  readonly productId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "PathwaySequenceDashboardBlockFragment";
};
export type PathwaySequenceDashboardBlockFragment$key = {
  readonly " $data"?: PathwaySequenceDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PathwaySequenceDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PathwaySequenceDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    }
  ],
  "type": "PathwaySequenceDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "040fd800bb4322ede4c95e6647653607";

export default node;
